import dayjs from 'dayjs'
import {
  userRoles,
  statuses,
  sportKinds,
  genders,
  ROLE_USER,
  weightStatuses,
  matchStatuses,
} from '../../utils/constants'

export function formatDate(date, format = 'DD.MM.YYYY') {
  if (date) return dayjs(date).format(format)
  return 'Не указано'
}

export const formatGender = (gender) => {
  if (gender === genders[gender]?.value) return genders[gender].text
}

export const formatDeleted = (deleted) => {
  if (deleted) return 'Да'
  if (!deleted) return 'Нет'
}

export const formatStatus = (status) => {
  if (status === statuses[status]?.value) return statuses[status].text
}

export const formatSportKind = (sportKind) => {
  if (sportKind === sportKinds[sportKind]?.value)
    return sportKinds[sportKind].text
}

export const formatRole = (role) => {
  if (role === ROLE_USER) return null
  return userRoles[role]?.text || role
}

export const formatWeightStatus = (status) => {
  if (status === weightStatuses[status]?.value)
    return weightStatuses[status].text
}

export const formatMatchStatus = (status) => {
  if (status === matchStatuses[status]?.value) return matchStatuses[status].text
}
